// /Restaurant/sugarcane-cafe/frontend/src/services/reservationService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const createReservation = async (reservationData) => {
    try {
        const response = await axios.post(`${API_URL}/api/reservations`, reservationData);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const getReservations = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/reservations`); // Updated endpoint
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const deleteReservation = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/api/reservations/${id}`); // Updated endpoint
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const getCustomerReservations = async (customerId) => {
    try {
        const response = await axios.get(`${API_URL}/api/reservations/customer/${customerId}`); // Updated endpoint
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const cancelReservation = async (reservationId) => {
    try {
        const response = await axios.delete(`${API_URL}/api/reservations/${reservationId}`); // Updated endpoint
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};